var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('forgot-pass',{attrs:{"returnUrl":_vm.returnUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }